import { render, staticRenderFns } from "./benefitUsageRecord.vue?vue&type=template&id=c8312b96&scoped=true"
import script from "./benefitUsageRecord.vue?vue&type=script&lang=js"
export * from "./benefitUsageRecord.vue?vue&type=script&lang=js"
import style0 from "./benefitUsageRecord.vue?vue&type=style&index=0&id=c8312b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8312b96",
  null
  
)

export default component.exports